import { FC } from 'react';
import {
  Database,
  Grid,
  Image,
  Layers,
  Triangle,
  Type,
  Zap,
} from 'react-feather';
import styled from 'styled-components';

import Tabs from './Tabs/Tabs';
import CSSWidget from './Widgets/CSSWidget';
import KvsWidget from './Widgets/KvsWidget';
import TextWidget from './Widgets/TextWidget';
import MediaWidget from './Widgets/MediaWidget';
import InfoWidgets from './Widgets/InfoWidgets';
import ShapeWidget from './Widgets/ShapesWidget';
import LayersPanel from './Layers/LayersPanel';
import QrCodePanel from './QrCode/QrCodePanel';

const SidePanelContainer = styled.div`
  display: flex;
  flex: none;
  min-height: 0;
`;

const ICON_SIZE = 20;

const tabs = [
  {
    title: 'Text',
    icon: <Type size={ICON_SIZE} />,
    children: <TextWidget />,
  },
  {
    title: 'Media',
    icon: <Image size={ICON_SIZE} />,
    children: <MediaWidget />,
  },
  {
    title: 'Shapes',
    icon: <Triangle size={ICON_SIZE} />,
    children: <ShapeWidget />,
  },
  {
    title: 'Apps',
    icon: <Grid size={ICON_SIZE} />,
    children: <InfoWidgets />,
  },
  {
    title: 'QR code',
    icon: (
      <svg
        width={ICON_SIZE}
        height={ICON_SIZE}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <path d="M14 14h3v3h-3zM18 18h3v3h-3zM14 20h1M20 14h1" />
      </svg>
    ),
    children: <QrCodePanel />,
  },
  {
    title: 'Data',
    panelTitle: 'Dynamic data (KVS)',
    icon: <Database size={ICON_SIZE} />,
    children: <KvsWidget />,
  },
  {
    title: 'Layers',
    icon: <Layers size={ICON_SIZE} />,
    children: <LayersPanel />,
  },
  {
    title: 'Animate',
    panelTitle: 'CSS animations',
    icon: <Zap size={ICON_SIZE} />,
    children: <CSSWidget />,
  },
];

const SidePanel: FC = () => {
  return (
    <SidePanelContainer>
      <Tabs tabs={tabs} id="side-panel" />
    </SidePanelContainer>
  );
};

export default SidePanel;
